import React, { useEffect, useRef, useState } from "react";
import StepSlider from "../../commonComponents/StepSlider";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./step2.css";
import { useDispatch, useSelector } from "react-redux";
import { updateInsuredData } from "../../redux/Slice";
import relation from "../../../relation.json";
import { useSpring, animated } from "@react-spring/web";
import { GiUmbrella } from "react-icons/gi";
import { selectProposal } from "../../redux/Slice";
// material Component
import InputLabel from "@mui/material/InputLabel";
import { Helmet } from "react-helmet-async";
import { Typography } from "@mui/material";
import { IconButton, Box, FormControl, Select, MenuItem } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { calculateAge } from "../../helper/common";

const HealthStep2 = () => {
  const dispatch = useDispatch();
  const [familyData, setFamilyData] = useState([]);
  const [selectedAge, setSelectedAge] = useState(
    Array(familyData.length).fill("")
  );
  const [isSelectOpen, setIsSelectOpen] = useState({});
  const [insuredRelation, setInsuredRelation] = useState([]);

  const [AgeSelectError, SetAgeSelectError] = useState("");
  const [selectedDetails, setSelectedDetails] = useState([]);

  const [dobData, setDobData] = useState(null);
  const [ageType, setAgeType] = useState("age");
  const [members, setMembers] = useState([]);

  const navigate = useNavigate();
  const selectRef = useRef(null);
  const ages = Array.from({ length: 121 }, (_, i) => i);
  const selfWifeAges = Array.from({ length: 82 }, (_, i) => i + 18);
  const brotherSisterAges = Array.from({ length: 82 }, (_, i) => i + 26);

  const parentAges = Array.from({ length: 60 }, (_, i) => i + 40);
  const sonDaughterAges = Array.from({ length: 30 }, (_, i) =>
    i === 0 ? 0 : i
  );
  const grandparentAges = Array.from({ length: 46 }, (_, i) => i + 54);

  const proposalData = useSelector(selectProposal);

  const personType = localStorage.getItem("selectedType");

  useEffect(() => {
    const retrievedInsuredDetail = localStorage.getItem("InsuredDetail");
    if (retrievedInsuredDetail) {
      const parsedInsuredDetail = JSON.parse(retrievedInsuredDetail);
      setFamilyData(parsedInsuredDetail);
    }

    const storedInsuredDetail = localStorage.getItem("InsuredDetail");
    if (storedInsuredDetail) {
      const parsedInsuredDetail = JSON.parse(storedInsuredDetail);
      const storedInsuredRelation = parsedInsuredDetail.map(
        (detail) => detail.InsuredRelation
      );
      const storedInsuredAge = parsedInsuredDetail.map((detail) =>
        String(detail.InsuredAge)
      );
      setInsuredRelation(storedInsuredRelation);

      setSelectedAge(storedInsuredAge);
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAgeChange = (index, event) => {
    const { value } = event.target;

    dispatch(
      updateInsuredData({
        index: index,
        data: [{ key: "InsuredAge", value: value }],
      })
    );
    const updatedInsuredRelation = [...insuredRelation];
    updatedInsuredRelation[index] = familyData[index].InsuredRelation;
    localStorage.setItem("ageadded", value);
    setSelectedAge((prevSelectedAge) => {
      const updatedSelectedAge = [...prevSelectedAge];
      updatedSelectedAge[index] = value;
      return updatedSelectedAge;
    });
    setInsuredRelation(updatedInsuredRelation);
  };

  const toggleSelect = (index) => {
    setIsSelectOpen((prevIsSelectOpen) => ({
      ...prevIsSelectOpen,
      [index]: !prevIsSelectOpen[index],
    }));
  };

  const handleClickOutside = (e) => {
    if (selectRef.current && !selectRef.current.contains(e.target)) {
      setIsSelectOpen(false);
    }
  };

  const validateAgeSelection = () => {
    const isAllAgesSelected = selectedAge.every((age) => age !== "");

    if (!isAllAgesSelected) {
      SetAgeSelectError(false);

      setTimeout(() => {
        SetAgeSelectError(true);
      }, 10);
      return false;
    }

    for (let i = 0; i < selectedAge.length; i++) {
      const currentRelation = insuredRelation[i];
      const currentAge = parseInt(selectedAge[i]);

      if (currentRelation === "Self" && currentAge < 18) {
        toast.error("You must be at least 18 years old to select yourself.", {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        return false;
      }

      // 2. Validate relationships for age hierarchy
      for (let j = 0; j < selectedAge.length; j++) {
        if (i !== j) {
          const comparisonRelation = insuredRelation[j];
          const comparisonAge = parseInt(selectedAge[j]);

          // 3. Grandparent must be older than Self, Son, Daughter, and Parents
          if (
            (currentRelation === "Grand Father" ||
              currentRelation === "Grand Mother") &&
            (comparisonRelation === "Self" ||
              comparisonRelation === "Son" ||
              comparisonRelation === "Daughter" ||
              comparisonRelation === "Father" ||
              comparisonRelation === "Mother" ||
              comparisonRelation === "Father In Law" ||
              comparisonRelation === "Mother In Law") &&
            currentAge <= comparisonAge
          ) {
            toast.error(
              "Grandparent's age must be greater than Self, Son, Daughter, or Parent's age.",
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              }
            );
            return false;
          }

          if (
            (currentRelation === "Father" ||
              currentRelation === "Mother" ||
              currentRelation === "Father In Law" ||
              currentRelation === "Mother In Law") &&
            (comparisonRelation === "Self" ||
              comparisonRelation === "Son" ||
              comparisonRelation === "Daughter") &&
            currentAge <= comparisonAge
          ) {
            toast.error(
              "Parent's age must be greater than Self, Son, or Daughter's age.",
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              }
            );
            return false;
          }

          // 5. Son's age must always be less than all higher hierarchy members (Self, Father, Mother, Grandparents, Father-in-law, Mother-in-law)
          if (
            currentRelation === "Son" &&
            (comparisonRelation === "Self" ||
              comparisonRelation === "Father" ||
              comparisonRelation === "Mother" ||
              comparisonRelation === "Grand Father" ||
              comparisonRelation === "Grand Mother" ||
              comparisonRelation === "Father In Law" ||
              comparisonRelation === "Mother In Law") &&
            currentAge >= comparisonAge
          ) {
            toast.error(
              "Son's age must be less than Self, Father, Mother, Grandfather, or Grandmother.",
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              }
            );
            return false;
          }

          // 6. Daughter's age must always be less than all higher hierarchy members (Self, Father, Mother, Grandparents, Father-in-law, Mother-in-law)
          if (
            currentRelation === "Daughter" &&
            (comparisonRelation === "Self" ||
              comparisonRelation === "Father" ||
              comparisonRelation === "Mother" ||
              comparisonRelation === "Grand Father" ||
              comparisonRelation === "Grand Mother" ||
              comparisonRelation === "Father In Law" ||
              comparisonRelation === "Mother In Law") &&
            currentAge >= comparisonAge
          ) {
            toast.error(
              "Daughter's age must be less than Self, Father, Mother, Grandfather, or Grandmother.",
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              }
            );
            return false;
          }

          // 7. Sibling's ages (Brother, Sister) must not be the same
          if (
            (currentRelation === "Brother" || currentRelation === "Sister") &&
            (comparisonRelation === "Brother" ||
              comparisonRelation === "Sister") &&
            currentAge === comparisonAge
          ) {
            toast.error("Siblings' ages should not be the same.", {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
            return false;
          }

          // 8. Ensure Brother or Sister's age is less than all higher relations (Self, Father, Mother, Grandparents, Father-in-law, Mother-in-law)
          if (
            (currentRelation === "Brother" || currentRelation === "Sister") &&
            (comparisonRelation === "Self" ||
              comparisonRelation === "Father" ||
              comparisonRelation === "Mother" ||
              comparisonRelation === "Grand Father" ||
              comparisonRelation === "Grand Mother" ||
              comparisonRelation === "Father In Law" ||
              comparisonRelation === "Mother In Law") &&
            currentAge >= comparisonAge
          ) {
            toast.error(
              "Brother's or Sister's age must be less than Self, Father, Mother, Grandfather, or Grandmother.",
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
              }
            );
            return false;
          }
        }
      }
    }

    // If all validations pass, proceed
    return true;
  };

  const handleSetValue = () => {
    if (!validateAgeSelection()) {
      return;
    }

    const data_insured = localStorage.getItem("InsuredDetail");

    let insuredData = JSON.parse(data_insured);

    let InsuredDetail = selectedAge.map((age, index) => ({
      InsuredRelation: insuredRelation[index],
      genderType: insuredData[index].genderType,
      InsuredAge: age == 0 ? 0 : parseInt(age),
      dateOfbirth: selectedDetails[index]?.dateOfbirth || "",
    }));

    // alert(JSON.stringify(InsuredDetail[0]));

    localStorage.setItem("InsuredDetail", JSON.stringify(InsuredDetail));

    InsuredDetail.forEach((item) => {
      if (item.InsuredRelation == "Self") {
        if (item?.dateOfbirth) {
          localStorage.setItem("dateOfbirth", item?.dateOfbirth);
        }
      }
    });
    navigate("/healthStep3");
  };

  const getPersonImage = (persion, typedata) => {
    const familydata = relation.find(
      (value) => value.level == persion && value.type == typedata
    );
    return familydata["image1"];
  };

  const [isVisible, setIsVisible] = React.useState(false);

  const animations = useSpring({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0%)" : "translateY(50%)",
    config: { mass: 1, tension: 100, friction: 20, duration: 500 },
  });

  const getAgeLimitsByRelation = (relation) => {
    switch (relation) {
      case "Self":
      case "Wife":
      case "Husband":
      case "Brother":
      case "Sister":
        return { min: 18, max: 99 };
      case "Father":
      case "Mother":
      case "Uncle":
      case "Aunt":
      case "Father In Law":
      case "Mother In Law":
        return { min: 40, max: 99 };
      case "Son":
      case "Daughter":
        return { min: 1, max: 29 };
      case "Grand Father":
      case "Grand Mother":
        return { min: 54, max: 99 };
      default:
        return { min: 1, max: 99 };
    }
  };

  const getDateLimitsFromAge = (minAge, maxAge) => {
    const today = dayjs();
    return {
      maxDate: today.subtract(minAge, "year"),
      minDate: today.subtract(maxAge, "year"),
    };
  };

  const handleDateSelection = (date, index) => {
    if (!date) return;

    const formattedDate = date.format("YYYY-MM-DD");
    const calculatedAge = calculateAge(date);

    // ✅ 1. Update Redux (same as handleAgeChange)
    dispatch(
      updateInsuredData({
        index: index,
        data: [
          { key: "InsuredAge", value: calculatedAge },
          { key: "dateOfbirth", value: formattedDate },
        ],
      })
    );

    // ✅ 2. Update relation (same pattern as your age function)
    const updatedInsuredRelation = [...insuredRelation];
    updatedInsuredRelation[index] = familyData[index].InsuredRelation;

    // ✅ 3. Store in localStorage (same behavior)
    localStorage.setItem("ageadded", calculatedAge);

    // ✅ 4. Update selectedAge (same as age change)
    setSelectedAge((prev) => {
      const updated = [...prev];
      updated[index] = calculatedAge;
      return updated;
    });

    // ✅ 5. Update DOB state (IMPORTANT)
    setSelectedDetails((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        dateOfbirth: formattedDate,
      };
      return updated;
    });

    // ✅ 6. Update relation state
    setInsuredRelation(updatedInsuredRelation);
  };
  // const handleDateSelection = (date, index) => {
  //   if (date) {
  //     const formattedDate = dayjs(date).format("YYYY-MM-DD"); // Convert to "YYYY-MM-DD"

  //     const calculatedAge = calculateAge(date);
  //     setDobData(date);

  //     setSelectedDetails((prevDetails) => {
  //       const newDetails = [...prevDetails];
  //       newDetails[index] = {
  //         dateOfbirth: formattedDate, // Store in "YYYY-MM-DD" format
  //       };
  //       return newDetails;
  //     });

  //     setSelectedAge((prevAges) => {
  //       const newAges = [...prevAges];
  //       newAges[index] = calculatedAge;
  //       return newAges;
  //     });

  //     handleAgeChange(index, { target: { value: calculatedAge } });
  //   }
  // };
  console.log("familyData", familyData);
  useEffect(() => {
    setIsVisible(true);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <h1
        style={{
          textAlign: "center",
          padding: "20px",
          color: "#0055A5",
          marginTop: 20,
        }}
      >
        We Offer You Best Insurance Plan{" "}
        <span style={{ color: "#E50318" }}>In Your </span>
        <span style={{ color: "#FD9202" }}>Budget</span>
        <sup>**</sup>
      </h1>

      <StepSlider activeStep={2} />

      <animated.div style={animations}>
        <div className="health-insurance-view-plan">
          <div className="modal-body">
            <div className="modal-content" style={{ border: "none" }}>
              <div className="modle-title">
                <h6 className="selectmemberh6">
                  Select Members You Want To Insure
                </h6>
              </div>

              <div
                className={
                  AgeSelectError
                    ? "shaking container tooltipposition"
                    : "container tooltipposition"
                }
                style={{ textAlign: "center" }}
              >
                <div className="tooltips">
                  <div>
                    <div className="toolchild">
                      <span className="umbrellaspan">
                        <GiUmbrella />
                      </span>
                      <h6>Best Discount Only for you in limited Price </h6>
                    </div>
                  </div>
                </div>
                <p
                  style={{
                    color: "red",
                    textAlign: "center",
                    position: "relative",
                    top: "0px",
                    marginBottom: "0",
                  }}
                >
                  {AgeSelectError ? "Please select at least one option." : ""}
                </p>
                {/* <div className="age-toggle-wrapper">
                  <label
                    className={`age-toggle ${
                      ageType === "age" ? "active" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="ageType"
                      value="age"
                      checked={ageType === "age"}
                      onChange={(e) => setAgeType(e.target.value)}
                    />
                    <span>Check by Age</span>
                  </label>

                  <label
                    className={`age-toggle ${
                      ageType === "dob" ? "active" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="ageType"
                      value="dob"
                      checked={ageType === "dob"}
                      onChange={(e) => setAgeType(e.target.value)}
                    />
                    <span>Check by Date of Birth</span>
                  </label>
                </div> */}

                <div className="row ">
                  <div className="col-md-8" style={{ margin: "0 auto" }}>
                    {familyData.map((item, index) => (
                      <div key={index} className="row agerow">
                        <div className="col-xs-9 helthtwoimagediv">
                          <img
                            src={getPersonImage(
                              item.InsuredRelation,
                              personType
                            )}
                            alt=""
                          />
                          <span className="font20">
                            {item.InsuredRelation}{" "}
                          </span>
                        </div>
                        <div className="col-xs-3 text-right selectdiv">
                          <div
                            style={{
                              position: "relative",
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                            ref={selectRef}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              {/* ✅ AGE SELECT */}
                              {ageType === "age" && (
                                <FormControl sx={{ m: 0.3, minWidth: 120 }}>
                                  <Select
                                    className="selectvalues"
                                    id={`age.${item}`}
                                    name={`age.${item}`}
                                    value={selectedAge[index] ?? ""}
                                    onChange={(event) =>
                                      handleAgeChange(index, event)
                                    }
                                    sx={{
                                      color: "grey",
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        border: "none",
                                      },
                                    }}
                                    displayEmpty
                                  >
                                    <MenuItem
                                      value=""
                                      disabled
                                      sx={{ color: "#555" }}
                                    >
                                      Select Age
                                    </MenuItem>

                                    {/* Relations logic (same as yours) */}
                                    {["Self", "Wife", "Husband"].includes(
                                      item.InsuredRelation
                                    ) &&
                                      selfWifeAges.map((value) => (
                                        <MenuItem
                                          key={value}
                                          value={value}
                                          sx={{ color: "grey" }}
                                        >
                                          {value} Years
                                        </MenuItem>
                                      ))}

                                    {["Brother", "Sister"].includes(
                                      item.InsuredRelation
                                    ) &&
                                      brotherSisterAges.map((value) => (
                                        <MenuItem
                                          key={value}
                                          value={value}
                                          sx={{ color: "grey" }}
                                        >
                                          {value} Years
                                        </MenuItem>
                                      ))}

                                    {["Son", "Daughter"].includes(
                                      item.InsuredRelation
                                    ) &&
                                      sonDaughterAges.map((value) => (
                                        <MenuItem
                                          key={value}
                                          value={value}
                                          sx={{ color: "grey" }}
                                        >
                                          {value === 0
                                            ? "<91 Days"
                                            : `${value} Years`}
                                        </MenuItem>
                                      ))}

                                    {["Grand Father", "Grand Mother"].includes(
                                      item.InsuredRelation
                                    ) &&
                                      grandparentAges.map((value) => (
                                        <MenuItem
                                          key={value}
                                          value={value}
                                          sx={{ color: "grey" }}
                                        >
                                          {value} Years
                                        </MenuItem>
                                      ))}

                                    {[
                                      "Father",
                                      "Mother",
                                      "Uncle",
                                      "Aunt",
                                      "Father In Law",
                                      "Mother In Law",
                                    ].includes(item.InsuredRelation) &&
                                      parentAges.map((value) => (
                                        <MenuItem
                                          key={value}
                                          value={value}
                                          sx={{ color: "grey" }}
                                        >
                                          {value} Years
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                              )}

                              {/* ✅ DOB PICKER */}
                              {ageType === "dob" && (
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DatePicker
                                    views={["year", "month", "day"]}
                                    format="DD-MM-YYYY"
                                    // value={
                                    //   item.dateOfbirth
                                    //     ? dayjs(item.dateOfbirth, "YYYY-MM-DD")
                                    //     : null
                                    // }
                                    value={
                                      selectedDetails[index]?.dateOfbirth
                                        ? dayjs(
                                            selectedDetails[index].dateOfbirth,
                                            "YYYY-MM-DD"
                                          )
                                        : item.dateOfbirth
                                        ? dayjs(item.dateOfbirth, "YYYY-MM-DD")
                                        : null
                                    }
                                    onChange={(date) =>
                                      handleDateSelection(date, index)
                                    }
                                    className="health-step2-date"
                                    minDate={
                                      getDateLimitsFromAge(
                                        getAgeLimitsByRelation(
                                          item.InsuredRelation
                                        ).min,
                                        getAgeLimitsByRelation(
                                          item.InsuredRelation
                                        ).max
                                      ).minDate
                                    }
                                    maxDate={
                                      getDateLimitsFromAge(
                                        getAgeLimitsByRelation(
                                          item.InsuredRelation
                                        ).min,
                                        getAgeLimitsByRelation(
                                          item.InsuredRelation
                                        ).max
                                      ).maxDate
                                    }
                                    slotProps={{
                                      textField: {
                                        sx: {
                                          "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              border: "none",
                                            },
                                        },
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              )}
                            </Box>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="buttons-container">
                  <button
                    className="continuebutton myBtn"
                    onClick={handleSetValue}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </animated.div>
      <ToastContainer />
    </>
  );
};

export default HealthStep2;
